import Vue from 'vue';
import { HTTP } from '../../../../utils/httpCommonUtil';
import { BallPulseLoader } from 'vue-loaders';
import VueSimpleSpinner from 'vue-simple-spinner'
import { getRestParamErrorMessage } from '@/utils/serverErrorMessageUtil';
import { UserRoleEnum } from '@/enums/userRolesEnum';
import GenericModal1 from '@/componentsReusable/genericModal.vue';
import GenericModal2 from '@/componentsReusable/genericModal.vue';
import facilityEventHub from '@/components/facility/FacilityEventHub';

export default Vue.component('facility-specialty-requirements-card', {
  name: 'FacilitySpecialtyRequirementsCard',
  data () {
    return {
      cardExpanded: false,
      loadingInitialData: false,
      isAuthorizedToDelete: false,
      showConfirmationModal1: false,
      showConfirmationModal2: false,
      facilitySpecialtyRequirement: [],
      savingNewFacilitySpecialtyRequirement: false,
      systemProviderTypes: [],
      selectedSystemProviderType: null,
      facilitySpecialtyRequirementProviderTypes: [],
      facilitySpecialtyRequirementProviderType: [],
      pendingDeleteProviderType: null,
      systemCertificationTypes: [],
      selectedSystemCertificationType: null,
      facilitySpecialtyRequirementCertificationTypes: [],
      facilitySpecialtyRequirementCertificationType: [],
      pendingDeleteCertificationType: null,
      providerTypeIdErrorMessage: '',
      certificationTypeIdErrorMessage: ''
    }
  },
  components: {
    BallPulseLoader,
    VueSimpleSpinner,
    'generic-modal1' : GenericModal1,
    'generic-modal2' : GenericModal2
  },
  beforeMount: function () {
    this.isAuthorizedToDelete = this.$store.getters['user/hasRole']([UserRoleEnum.MANAGER]);
  },
  created: function () {
    facilityEventHub.$on('SPECIALTY_CHANGE', this.specialtyChangeEvent)
  },
  beforeDestroy: function () {
    facilityEventHub.$off('SPECIALTY_CHANGE', this.specialtyChangeEvent)
  },
  filters: {
  },
  methods: {
    specialtyChangeEvent () {
      setTimeout( () => {
        this.getFacilitySpecialtyBoardCertification();
        this.getSystemCertificationTypes();
        this.getSystemProviderTypes();
        this.getFacilitySpecialtyRequirementProviderTypes();
        this.getFacilitySpecialtyRequirementCertificationTypes();
      },0);
    },
    expandCard () {
      this.cardExpanded = !this.cardExpanded;
      if (this.cardExpanded) {
        this.getFacilitySpecialtyBoardCertification();
        this.getSystemCertificationTypes();
        this.getSystemProviderTypes();
        this.getFacilitySpecialtyRequirementProviderTypes();
        this.getFacilitySpecialtyRequirementCertificationTypes();
      }
    },

    getFacilitySpecialtyBoardCertification () {
      let self = this
      let showLoadingSpinnerTimeout = setTimeout(function () {
        self.loadingInitialData = true;
      }, 0);
      let facilityId = this.$route.params.facilityId;
      let specialtyId = this.$route.params.specialtyId;
      HTTP.get('/api/facilities/' + facilityId + '/specialties/' + specialtyId + '/requirements')
      .then(function (response) {
        let facilitySpecialtyRequirement: any;
        clearTimeout(showLoadingSpinnerTimeout);
        self.loadingInitialData = false;
        if (!response.data || !response.data.data) { 
          facilitySpecialtyRequirement.facilityId = facilityId;
          facilitySpecialtyRequirement.specialtyId = specialtyId;
          facilitySpecialtyRequirement.isBoardCertificationReqd = false;
          self.saveFacilitySpecialtyRequirement (facilitySpecialtyRequirement);
          self.getFacilitySpecialtyBoardCertification();
        }
        let freshFacilitySpecialtyRequirement = response.data.data;
        freshFacilitySpecialtyRequirement.forEach( function (facilitySpecialtyRequirement: any) {
          facilitySpecialtyRequirement.isEditing = true;
          facilitySpecialtyRequirement.isNew = false;
          facilitySpecialtyRequirement.updatingData = false;
          self.facilitySpecialtyRequirement = facilitySpecialtyRequirement;
        })
      })
      .catch(function (err) {
        console.log('response Error!');
        console.log(err);
        clearTimeout(showLoadingSpinnerTimeout);
        self.loadingInitialData = false;
        self.$notify({
          group: 'main',
          type: 'error',
          title: 'Error',
          text: 'An error occurred retrieving Facility Specialty Requirements.'
        });
      })
    },

    getSystemProviderTypes () {
      let self = this
      HTTP.get('/api/provider-types/')
      .then(function (response) {
        if (!response.data || !response.data.data) { 
          throw new Error("Error retrieving Provider types.");
        }
        self.systemProviderTypes = response.data.data;
      })
      .catch(function (err) {
        console.log('response Error!');
        console.log(err);
        self.$notify({
          group: 'main',
          type: 'error',
          title: 'Error',
          text: 'An error occurred retrieving Provider types.'
        });
      })
    },

    getSystemCertificationTypes () {
      let self = this
      HTTP.get('/api/certificationTypes')
      .then(function (response) {
        if (!response.data || !response.data.data) { 
          throw new Error("Error retrieving Certifications.");
        }
        self.systemCertificationTypes = response.data.data;
      })
      .catch(function (err) {
        console.log('response Error!');
        console.log(err);
        self.$notify({
          group: 'main',
          type: 'error',
          title: 'Error',
          text: 'An error occurred retrieving Certification types.'
        });
      })
    },

    saveFacilitySpecialtyRequirement (facilitySpecialtyRequirement: any) {
      HTTP.post('/api/facilities/' + facilitySpecialtyRequirement.facilityId + '/specialties/' + facilitySpecialtyRequirement.specialtyId + '/addRequirement/');
    },
    facilitySpecialtyRequirementGeneralChange (boardCertificationReqd: any) {
      let self = this;
      let facilityId = this.$route.params.facilityId;
      let specialtyId = this.$route.params.specialtyId;
      HTTP.put('/api/facilities/' + facilityId + '/specialties/' + specialtyId + '/boardCertification/' + boardCertificationReqd + '/updateRequirement/')
      .then(function (response) {
        self.$notify({
          group: 'main',
          type: 'success',
          title: 'Successfully Updated',
          text: 'Successfully updated Facility Specialty Requirement.',
        });
      })
      .catch(function () {
        self.$notify({
          group: 'main',
          type: 'error',
          title: 'Error',
          text: 'An error occurred updating Facility Specialty Requirement.'
        });
      })
    },

    getFacilitySpecialtyRequirementProviderTypes () {
      let self = this
      let showLoadingSpinnerTimeout = setTimeout(function () {
        self.loadingInitialData = true;
      }, 0);
      let facilityId = this.$route.params.facilityId;
      let specialtyId = this.$route.params.specialtyId;
      HTTP.get('/api/facilities/' + facilityId + '/specialties/' + specialtyId + '/getProviderTypes/')
      .then(function (response) {
        clearTimeout(showLoadingSpinnerTimeout);
        self.loadingInitialData = false;
        if (!response.data || !response.data.data) {
          throw new Error("Error retrieving Facility Specialty Provider Types.");
        }
        let freshProviderTypes = response.data.data;
        freshProviderTypes.forEach( function (providerType: any) {
          return false;
        });
        self.facilitySpecialtyRequirementProviderTypes = freshProviderTypes;
      })
      .catch(function () {
        console.log('response Error!');
        clearTimeout(showLoadingSpinnerTimeout);
        self.loadingInitialData = false;
        self.$notify({
          group: 'main',
          type: 'error',
          title: 'Error',
          text: 'An error occurred retrieving Provider Types.'
        });
      })
    },
    deleteConfirmed1 (facilitySpecialtyProviderTypeId: any) {
      this.showConfirmationModal1 = false;
      this.deleteFacilitySpecialtyRequirementProviderType (this.pendingDeleteProviderType, true);
    },
    deleteFacilitySpecialtyRequirementProviderType (facilitySpecialtyProviderTypeId: any, bypassDeleteConfirmation: boolean = false ) {
      if (!bypassDeleteConfirmation) {
        // Show Delete Confirmation Modal
        this.showConfirmationModal1 = true;
        this.pendingDeleteProviderType = facilitySpecialtyProviderTypeId;
        return;
      } else {
        this.pendingDeleteProviderType = null;
      }
      let self = this
      let showLoadingSpinnerTimeout = setTimeout(function () {
        self.loadingInitialData = true;
      }, 0);
      let facilityId = this.$route.params.facilityId;
      let specialtyId = this.$route.params.specialtyId;
      let providerTypeId = facilitySpecialtyProviderTypeId;
      HTTP.post('/api/facilities/' + facilityId + '/specialties/' + specialtyId + '/providerType/' + providerTypeId + '/deleteProviderType/')
      .then(function (response) {
        clearTimeout(showLoadingSpinnerTimeout);
        self.loadingInitialData = false;
        self.getFacilitySpecialtyRequirementProviderTypes();
        // self.$notify({
        //   group: 'main',
        //   type: 'success',
        //   title: 'Successful Provider Type Delete.',
        //   text: 'Provider Type has been successfully deleted.'
        // });
      })
      .catch(function () {
        console.log('response Error!');
        clearTimeout(showLoadingSpinnerTimeout);
        self.loadingInitialData = false;
        self.$notify({
          group: 'main',
          type: 'error',
          title: 'Error',
          text: 'An error occurred deleting Provider Type.'
        });
      })
    },

    getFacilitySpecialtyRequirementCertificationTypes () {
      let self = this
      let showLoadingSpinnerTimeout = setTimeout(function () {
        self.loadingInitialData = true;
      }, 0);
      let facilityId = this.$route.params.facilityId;
      let specialtyId = this.$route.params.specialtyId;
      HTTP.get('/api/facilities/' + facilityId + '/specialties/' + specialtyId + '/getCertificationTypes/')
      .then(function (response) {
        clearTimeout(showLoadingSpinnerTimeout);
        self.loadingInitialData = false;
        if (!response.data || !response.data.data) {
          throw new Error("Error retrieving Facility Specialty Certifications.");
        }
        let freshCertifications = response.data.data;
        freshCertifications.forEach( function (providerType: any) {
          return false;
        });
        self.facilitySpecialtyRequirementCertificationTypes = freshCertifications;
      })
      .catch(function () {
        console.log('response Error!');
        clearTimeout(showLoadingSpinnerTimeout);
        self.loadingInitialData = false;
        self.$notify({
          group: 'main',
          type: 'error',
          title: 'Error',
          text: 'An error occurred retrieving Certifications.'
        });
      })
    },
    deleteConfirmed2 (facilitySpecialtyObjectTypeId: any) {
      this.showConfirmationModal2 = false;
      this.deleteFacilitySpecialtyRequirementCertificationType (this.pendingDeleteCertificationType, true);
    },
    deleteFacilitySpecialtyRequirementCertificationType (facilitySpecialtyCertificationTypeId: any, bypassDeleteConfirmation: boolean = false ) {
      if (!bypassDeleteConfirmation) {
        // Show Delete Confirmation Modal
        this.showConfirmationModal2 = true;
        this.pendingDeleteCertificationType = facilitySpecialtyCertificationTypeId;
        return;
      } else {
        this.pendingDeleteCertificationType = null;
      }
      let self = this
      let showLoadingSpinnerTimeout = setTimeout(function () {
        self.loadingInitialData = true;
      }, 0);
      let facilityId = this.$route.params.facilityId;
      let specialtyId = this.$route.params.specialtyId;
      let certificationTypeId = facilitySpecialtyCertificationTypeId;
      HTTP.post('/api/facilities/' + facilityId + '/specialties/' + specialtyId + '/certificationType/' + certificationTypeId + '/deleteCertificationType/')
      .then(function (response) {
        clearTimeout(showLoadingSpinnerTimeout);
        self.loadingInitialData = false;
        self.getFacilitySpecialtyRequirementCertificationTypes();
        // self.$notify({
        //   group: 'main',
        //   type: 'success',
        //   title: 'Successful Certification Delete.',
        //   text: 'Certification has been successfully deleted.'
        // });
      })
      .catch(function (err) {
        console.log('response Error! ' + err);
        clearTimeout(showLoadingSpinnerTimeout);
        self.loadingInitialData = false;
        self.$notify({
          group: 'main',
          type: 'error',
          title: 'Error',
          text: 'An error occurred deleting Certification.'
        });
      })
    },

    providerTypeChange (systemProviderType: any) {
      let self = this;
      let facilityId = this.$route.params.facilityId;
      let specialtyId = this.$route.params.specialtyId;
      let systemProviderTypeId = systemProviderType;
      self.providerTypeIdErrorMessage = '';
      if (systemProviderTypeId > 0) {
        HTTP.post('/api/facilities/' + facilityId + '/specialties/' + specialtyId + '/providerType/' + systemProviderTypeId + '/addProviderType/')
        .then(function (response) {
          self.selectedSystemProviderType = null;
          // self.$notify({
          //   group: 'main',
          //   type: 'success',
          //   title: 'Successfully Updated',
          //   text: 'Successfully updated Facility Specialty Requirement.'
          // });
          self.getFacilitySpecialtyRequirementProviderTypes();
        })
        .catch(function (err) {
          self.providerTypeIdErrorMessage = getRestParamErrorMessage(err, 'providerTypeId');
          if (
            !self.providerTypeIdErrorMessage.length
          ) {                       
            self.$notify({
              group: 'main',
              type: 'error',
              title: 'Error',
              text: 'An error occurred updating Facility Specialty Requirement.'
            });
          }
          
        })
      }
    },
    certificationTypeChange (systemCertificationType: any) {
      let self = this;
      let facilityId = this.$route.params.facilityId;
      let specialtyId = this.$route.params.specialtyId;
      let systemCertificationTypeId = systemCertificationType;
      self.certificationTypeIdErrorMessage = '';
      if (systemCertificationTypeId > 0) {
        HTTP.post('/api/facilities/' + facilityId + '/specialties/' + specialtyId + '/certificationType/' + systemCertificationTypeId + '/addCertificationType/')
        .then(function (response) {
          self.selectedSystemCertificationType = null;
          // self.$notify({
          //   group: 'main',
          //   type: 'success',
          //   title: 'Successfully Updated',
          //   text: 'Successfully updated Facility Specialty Requirement.'
          // });
          self.getFacilitySpecialtyRequirementCertificationTypes();
        })
        .catch(function (err) {
          self.certificationTypeIdErrorMessage = getRestParamErrorMessage(err, 'certificationTypeId');
          if (
            !self.certificationTypeIdErrorMessage.length
          ) {                       
            self.$notify({
              group: 'main',
              type: 'error',
              title: 'Error',
              text: 'An error occurred updating Facility Specialty Requirement.'
            });
          }
        })
      }
    }

    // facilitySpecialtyRequirementBoardCertificationChange (facilitySpecialtyRequirement: any) {
    //   console.log(facilitySpecialtyRequirement);
    //   this.systemCertificationTypes.forEach(function (certificationType: any) {
    //     if (facilitySpecialtyRequirement.facilityCertificationTypeId === certificationType.id) {
    //       facilitySpecialtyRequirement.facilityCertificationTypeName = certificationType.name;
    //     }
    //   });
    //   this.systemProviderTypes.forEach(function (providerType: any) {
    //     if (facilitySpecialtyRequirement.facilitySpecialtyProviderTypeId === providerType.id) {
    //       facilitySpecialtyRequirement.facilitySpecialtyProviderTypeName = providerType.name;
    //     }
    //   });
    // }

  }
})



// WEBPACK FOOTER //
// ./src/components/facility/cards/facilitySpecialtyRequirements/FacilitySpecialtyRequirementsCard.ts